















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { MenuItemModel } from '@/models/MenuItemModel';
import QuantityCount from '@/components/popups/menu-popup/QuantityCount.vue';
import { MenuExtraListModel } from '@/models/MenuExtraListModel';
import { MenuExtraListItemModel } from '@/models/MenuExtraListItemModel';
import {
  isMultiple, maxExtrasCount, requirementText, validateOrder, calculateOrderCost,
} from '@/utils/menu-popup-utils';
import { MenuItemSizeModel } from '@/models/MenuItemSizeModel';
import Note from '@/components/popups/menu-popup/Note.vue';
import ModItemHeader from '@/components/popups/menu-popup/ModItemHeader.vue';
import MenuPopupBar from '@/components/popups/menu-popup/MenuPopupBar.vue';
import { SelectedMenuItem, SelectedMenuItemFull } from '@/types';

@Component({
  components: {
    MenuPopupBar,
    ModItemHeader,
    Note,
    QuantityCount,
  },
  methods: {
    requirementText,
    isMultiple,
    maxExtrasCount,
  },
})
export default class MenuPopup extends Vue {
  @Prop() private selectedMenuItem!: SelectedMenuItem | SelectedMenuItemFull;

  private selectedExtras: Array<MenuExtraListItemModel[] | MenuExtraListItemModel | undefined> = [];

  private selectedSize: MenuItemSizeModel | null = null;

  private count = 1;

  private note = '';

  mounted(): void {
    this.checkSize();
    this.initSelections();
  }

  private onSave() {
    const {
      menuItem, selectedExtras, selectedSize, note, count, selectedMenuItem,
    } = this;

    const { merchantId, cartItemId } = selectedMenuItem as SelectedMenuItemFull;

    const saveModel: SelectedMenuItemFull = {
      menuItem,
      merchantId,
      selectedExtras,
      note,
      count,
      cartItemId,
      selectedSize: selectedSize as MenuItemSizeModel,
    };

    this.$emit('save', saveModel);
    this.$emit('close');
  }

  private checkSize(): void {
    if (this.menuItem.sizes.length === 1) {
      const [selectedSize] = this.menuItem.sizes;
      this.selectedSize = selectedSize;
    }
  }

  private initSelections(): void {
    const {
      selectedExtras, selectedSize, count, note,
    } = this.selectedMenuItem as SelectedMenuItemFull;

    if (selectedExtras) {
      this.selectedExtras = selectedExtras;
    }
    if (selectedSize) {
      this.selectedSize = selectedSize;
    }
    if (count) {
      this.count = count;
    }
    if (note) {
      this.note = note;
    }
  }

  private get menuItem(): MenuItemModel {
    return this.selectedMenuItem.menuItem;
  }

  private get extraLists(): MenuExtraListModel[] {
    return this.menuItem.extraLists.filter((e) => e.visible);
  }

  private get isMenuExtrasValid(): boolean {
    return validateOrder(this.menuItem, this.selectedExtras, this.selectedSize);
  }

  private get calculateCost(): string {
    return calculateOrderCost(this.selectedExtras, this.selectedSize, this.count);
  }
}
